export default {
  RESET_PHONE_STATE: 'RESET_PHONE_STATE',
  SET_IS_ADDING_PHONE: 'SET_IS_ADDING_PHONE',
  SET_IS_EDITING_PHONE: 'SET_IS_EDITING_PHONE',
};
